module.exports = __webpack_public_path__ + "img/calendar-15_fill.5aa954d4.svg";